export const FETCH_USER_LIST = 'FETCH_USER_LIST';
export const FETCH_USER_LIST_SUCCESS = 'FETCH_USER_LIST_SUCCESS';
export const FETCH_USER_LIST_FAIL = 'FETCH_USER_LIST_FAIL';

export const fetchUserList = () => ({
  type: FETCH_USER_LIST
});

export const fetchUserListSuccess = (userList) => ({
  type: FETCH_USER_LIST_SUCCESS,
  payload: userList
});

export const fetchUserListFail = () => ({
  type: FETCH_USER_LIST_FAIL
});
